export default "__VITE_ASSET__CJ1Hy72H__"